export default __webpack_public_path__ + "static/media/0x44a6e0be76e1d9620a7f76588e4509fe4fa8e8c8.54db7b17.webp";